<template>
 <div v-if="activeChannel">

<table v-if="otherChannels[0]" class="first-table">
            <tr>
                <td style="width: 87.7805%;" class="channels-name">{{ otherChannels[0].name }}</td>
                <td style="width: 15.2195%;" class="channels-code">{{ otherChannels[0].code }}</td>
            </tr>
        </table> 

     <div> 
        <div class="Controls">
            <a role="button"><img src="https://i.imgur.com/bafMwLL.png"  class="img-fluid icon ic-minus" alt="minus"></a>
            <img :src="activeChannel.img" class="img-fluid">
            <a role="button"><img src="https://i.imgur.com/W2VnosN.png"  class="img-fluid icon ic-plus" alt="plus"></a>

        </div>
            <td style="width: 87.7805%;" class="channels-name">{{ activeChannel.name }}</td>
            <td style="width: 15.2195%;" class="channels-code">{{ activeChannel.code }}</td>
         </div>

     <table v-if="otherChannels[1]" class="second-table">
            <tr>
                <td style="width: 87.7805%;" class="channels-name">{{ otherChannels[1].name }}</td>
                <td style="width: 15.2195%;" class="channels-code">{{ otherChannels[1].code }}</td>
            </tr>
    </table> 
 </div>
</template>

<script>
import Channels from './Channels.vue';

export default {
    data() {
        return {
            // showChannel: false,

        }
    },
    props: ['channels', 'currentChannels', 'activeChannel'],
    components: {
        appChannels:Channels,

    },
    methods:{
       
    },
    computed: {
        otherChannels() {
            return this.currentChannels.filter(item => item.code !== this.activeChannel.code)
        } 
    }
}
</script>

<style>
img{
    width:150px;
    border-radius: 50%;
    /* margin-top:15px;
    margin-bottom:15px; */
    margin: 35px 0;
}
img.icon{
    width: 30px;
}
.first-table{
        border-bottom: 1px solid #dee2e61a;


}
.channels-name{
    text-align: left;
    font-size: 16px;
    font-weight: 400;
}

.channels-code{
    text-align: right;
    font-size: 16px;
    font-weight: 900;
}
table tr{
    border-bottom: 1px solid #dee2e61a;
    color: #a2abbd;
    border-top:unset;
    cursor: pointer;
}
table tr:last-of-type{
    border-bottom:unset;
}
table tr td{
        padding-top: 10px;
        padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CurrentChannel.vue